/**
 * CSS Classes Constants
 * Contains all CSS class names, selectors, and modal classes
 */

export enum classes {
  SELECT_CONTAINER = '.m-select__container',
  DATA_PRIMARY = 'data-primary',
  LINE_FROM_ASSESSMENT = 'style-line-fromAssessment',
  AUTOCOMPLETE_LIST = 'm-autocomplete__list__ul__li',
  AUTOCOMPLETE_LIST_SPAN = 'm-autocomplete__list__ul__li__span',
  ASSESSMENT_SELF_MANAGEMENTE_DONUT_CLASS = '.container-assessment-self-management__donut-container',
}

export enum COMMENT_CLASSES {
  backdropClass = 'blur-backdrop',
  width = 'auto',
  panelClass = 'modal-comment',
  height = 'auto',
}

export enum SELECTOR_CLASSES {
  MainClass = '.m-select__main',
}

export const MODAL_CLASSES = {
  DEFAULT: 'modal__dialog',
  OVERFLOW_VISIBLE: 'modal__dialog modal__overflow-visible',
  SM_OVERFLOW_VISIBLE: 'modal__dialog modal__dialog--sm modal__overflow-visible',
  LG_OVERFLOW_VISIBLE: 'modal__dialog modal__dialog--lg modal__overflow-visible',
  BEHAVIORAL_LINES: 'modal__dialog modal__overflow-visible modal__dialog--behavioral-lines',
};

export const SELECTORS = {
  TEXTAREA: 'textArea',
  CONTAINERDIV: 'containerDiv',
  RESIZE_CONTAINER: 'resizeContainer',
  RESIZE_ICON: 'resizeIcon',
  INPUTTEXT: 'input',
};

export enum HTML_IDS {
  SecondAddEmail = 'secondAddEmail',
}

export enum HTML_ELEMENTS {
  InputLink = 'inputLink',
  InputText = 'inputText',
}

export const BTN_DISABLE = 'disable';
export const SENIORITY_SCORE_BUTTON_CLASS = 'is-level-up';
export const DEFAULT_DISCARD_BTN_CLASS = 'btn-discard btn-discard--fluid-sm';
export const DEFAULT_CONFIRM_BTN_CLASS = 'btn-confirm btn-confirm--fluid-sm';
export const BTN_SECONDARY_REVERSE_ICON = 'secondary reverse-icon';
export const BTN_PRIMARY_REVERSE_ICON = 'primary reverse-icon';
